"use client";

import { usePathname } from "next/navigation";
import { Header } from "../header";

/**
 * Conditional Header Component
 *
 * Renders the Header for all routes except /chat, public secure-link pages,
 * and public digital-card pages. On /chat, returns null for full-screen chat.
 * On /s/* (public secure links) and /card/* (public digital business cards),
 * returns null so unauthenticated visitors never see the internal Hub nav.
 */
export function ConditionalHeader() {
  const pathname = usePathname();

  // Hide header on chat route (full-screen chat) and public-facing pages.
  if (pathname === "/chat" || pathname.startsWith("/s/") || pathname.startsWith("/card/")) {
    return null;
  }

  return <Header />;
}
